import { render, staticRenderFns } from "./FrozenForm.vue?vue&type=template&id=4d44e832&scoped=true&"
import script from "./FrozenForm.vue?vue&type=script&lang=js&"
export * from "./FrozenForm.vue?vue&type=script&lang=js&"
import style0 from "./FrozenForm.vue?vue&type=style&index=0&id=4d44e832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d44e832",
  null
  
)

export default component.exports